/**
 * Created by izagarelos on 24/4/2018.
 */
import { mapState, mapActions, mapMutations } from 'vuex';

const FacebookMixin = {
  data() {
    return {
      token: '',
      fb_params: {
        scope: '', // 'public_profile,email,user_posts',
        return_scopes: true,
        enable_profile_selector: true,
      },
    };
  },
  methods: {
    share(fbId, duelId, successCallback, failCallback) {
      this.checkLoginStatus(fbId, this.params, this.getFbUserInfo, (response) => {
        // eslint-disable-next-line
        console.log(response);
        this.userId = response.id;
        if (!fbId) {
          this.connectFbAccount().then(() => {
            if (this.userAuthorized) {
              this.getUserLoginDetails().then(() => {
                this.updateUserLanguage();
                localStorage.setItem('FacebookImage', response.picture.data.url);
                this.sendFacebookImage().then(() => {
                  this.updateDisplayAvatar();
                  this.storeUserAvatar(response.picture.data.url);
                  this.shareAction(duelId, successCallback);
                });
              });
            } else {
              // eslint-disable-next-line
              console.log('error on connect fb account');
              this.logout(failCallback);
            }
          });
        } else {
          this.shareAction(duelId, successCallback);
        }
      }, failCallback);
    },
    shareAction(duelId, successCallback) {
      if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
        this.shareModalRedirect(duelId);
      } else {
        this.shareModalPopup(duelId, successCallback);
      }
    },
    shareModalRedirect(id) {
      const postInfoObject = JSON.stringify({
        object: {
          'og:url': `${this.redirectUrl}?fb_ref=${id}`,
        },
      });
      /* eslint-disable */
      window.location = 'https://m.facebook.com/v6.0/dialog/share?access_token=' + this.token +
        '&action_properties=' + encodeURIComponent(postInfoObject) +
        '&action_type=og.shares' +
        '&app_id=' + this.fbAppId +
        '&display=touch' +
        '&redirect_uri=' + encodeURIComponent(window.location.origin + '/publicapi/fbShareRedirect?userId=' + id + '&action=' + this.action + '&assign=' + (this.points || '') + '&callback=' + (window.location.href.includes('roundEnded') ? 'home' : '')) +
        '&sdk=joey' +
        '&version=v6.0';
      /* eslint-enable */
    },
    shareModalPopup(duelId, successCallback) {
      this.showShareModal(duelId, (resp) => {
        // eslint-disable-next-line
        console.log('resp:', resp);
        if (resp && !resp.error_code) {
          successCallback();
        }
      });
    },
    loginFbApi(permissions, fbId, callback, invalidFbError) {
      window.FB.login((res) => {
        if (res.authResponse) {
          this.token = res.authResponse.accessToken;
          localStorage.setItem('accessToken', res.authResponse.accessToken);
          this.authenticationValidation(res.authResponse.userID, fbId, this.getFbUserInfo, callback, invalidFbError);
        } else {
          // eslint-disable-next-line
          console.log('Error in facebookIntegration during login...');
          invalidFbError();
        }
      }, permissions);
    },
    checkLoginStatus(fbId, permissions, nextAction, callback, invalidFbError) {
      window.FB.login((res) => {
        // eslint-disable-next-line
        console.log(res);
        if (res.authResponse) {
          window.FB.getLoginStatus((response) => { // second check in case of inaccurate login status from FB.login() [it happens!]
            // eslint-disable-next-line
            console.log(response);
            if (response.authResponse && (response.status === 'connected' || response.status === 'not_authorized')) {
              this.token = response.authResponse.accessToken;
              this.authenticationValidation(response.authResponse.userID, fbId, nextAction, callback, invalidFbError);
            }
          }, true);
        }
      }, permissions);
    },
    authenticationValidation(userID, fbId, nextAction, callback, invalidFbError) {
      if (!fbId || userID === fbId) {
        nextAction(callback);
      } else {
        this.logout(invalidFbError);
      }
    },
    logout(callback) {
      window.FB.logout(() => {
        callback();
      });
    },
    connectFbAccount() {
      const userData = {
        accessToken: this.token,
        msisdn: this.userDetails.msisdn,
      };
      return this.callForAuthorizationFB(userData);
    },
    getFbUserInfo(callback) {
      window.FB.api('/me?fields=id,name,picture.width(300).height(300)', callback);
    },
    showShareModal(id, callback) {
      window.FB.ui({
        display: 'iframe',
        method: 'share',
        href: `${this.redirectUrl}?fb_ref=${id}`,
      }, callback);
    },
    forceFbToScrapNewMetadata(url, callback) {
      /* eslint-disable */
      window.FB.api(
        '/',
        'POST',
        { "scrape": "true", "id": url },
        callback);
      /* eslint-enable */
    },
    ...mapMutations('common', [
      'storeUserAvatar',
    ]),
    ...mapActions('common', [
      'sendFacebookImage',
      'updateDisplayAvatar',
    ]),
    ...mapActions('profile', [
      'callForAuthorizationFB',
      'getUserLoginDetails',
    ]),
    ...mapActions('i18n', [
      'updateUserLanguage',
    ]),
  },
  computed: {
    ...mapState('profile', [
      'userAuthorized',
    ]),
    ...mapState('common', [
      'userDetails',
      'fbAppId',
    ]),
  },
};

export default FacebookMixin;



// WEBPACK FOOTER //
// ./src/common/mixins/facebookIntegration.js